import React, { Component, PropTypes } from 'react';
import {findDOMNode} from 'react-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../redux/signInPopupActions';
import styles from 'src/styles/AuthPopup.scss';
import { hashPassword } from 'src/logic/authHelpers';
import config from 'src/config';
import * as texts from 'src/texts';
import TelephoneInput from 'react-telephone-input';
import {extractNumbers} from 'src/logic/utils';
import PopoverTrigger from 'src/components/popover/PopoverTrigger';
import {isValidNumber} from 'src/logic/utils';
import debounce from 'lodash/debounce';
import cx from 'classnames';
const phoneInputImgs = require('src/imgs/flags.png');
import fm from 'src/logic/formatMessage';

export class SignInPopupForm extends Component {
  state = {
    isPhoneValid: true
  };
  componentDidMount(){
    findDOMNode(this.refs.loginInput).children[0].focus();
  }
  onSubmit = (e) => {
    e.preventDefault();
    if (!this.state.isPhoneValid) {
      return false;
    }
    this.props.actions.signIn({
      phone: '+' + extractNumbers(findDOMNode(this.refs.loginInput).children[0].value),
      password: hashPassword(this.refs.passwordInput.value)
    });
  };

  onPhoneChange = debounce((e) => {
    if (e.length < config.minLengthForNumberVerifying) {
      this.setState({ isPhoneValid: true });
      return this.props.actions.resetErrors();
    }
    this.setState({
      isPhoneValid: isValidNumber(e)
    });
  }, 200);
  onPassChange = debounce(() => {
    this.setState({ isPhoneValid: true });
    return this.props.actions.resetErrors();
  }, 200);

  switchToPasswordResetting = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.actions.switchToPasswordResetting();
  };

  render() {
    const {actions} = this.props;
    const phoneNumberTooltipType = (!this.state.isPhoneValid || this.props.loginErr) && 'error';
    let phoneNumberTooltipText = this.state.isPhoneValid ? texts.enterNumberPrompt : texts.incorrectNumberErrText;
    if (this.props.loginErr) {
      phoneNumberTooltipText =  'Неверный логин или пароль.' ;//this.props.loginErr
    }
    const phoneNumberInputContainerClassName = {
      [styles.telephoneInputContainer]: true,
      [styles.invalidInput]: !this.state.isPhoneValid || !!this.props.loginErr,
      'w-100': true
    };
    return (
      <form onSubmit={this.onSubmit} className="m-t-1_5">
        <PopoverTrigger
          alwaysActive
          onTop
          type={phoneNumberTooltipType}
          content={fm(phoneNumberTooltipText)}
          placement="left">
          <div>
            <TelephoneInput
              ref="loginInput"
              classNames={cx(phoneNumberInputContainerClassName)}
              defaultCountry='ru'
              preferredCountries={config.phoneInputCodeSelectorPreferredCountries}
              initialValue={this.props.value || undefined}
              flagsImagePath={phoneInputImgs}
              onChange={this.onPhoneChange} />
          </div>
        </PopoverTrigger>
        <input
          required
          className="input-text w-100 m-t-0_5"
          ref="passwordInput"
          placeholder="Введите пароль"
          type="password"
          onChange={this.onPassChange}/>
        <button
          disabled={!this.state.isPhoneValid}
          className={styles.sendBtn}
          type="submit">
          Отправить
        </button>
        <a
          onClick={this.switchToPasswordResetting}
          className={styles.changeNumberPrompt}>Напомнить пароль</a>
      </form>
    );
  }
}



SignInPopupForm.propTypes = {
  actions: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    ...state.signInPopupReducer
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignInPopupForm);



/** WEBPACK FOOTER **
 ** ./src/components/SignInPopup/elements/SignInPopupForm.jsx
 **/